import React, { } from 'react';
import ImageList from '@mui/material/ImageList';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import OutfitsListItem from '../shared/OutfitsListItem';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function OutfitsList({ outfits, onPendingChange }) {
  const { t } = useTranslation();

  if (outfits == null) {
    return <><CircularProgress /></>
  }

  if (outfits.length === 0) {
    return (
      <Box sx={{ height: 680, padding: 3, fontStyle: 'italic' }}>
        <Alert variant="outlined" severity="info">
          {t('emptyOutfitList')}
          <Button variant="contained" color="primary" component={Link} to="/newOutfits" sx={{ marginTop: 3 }}>{t('newOutfit.title')}</Button>
        </Alert>
      </Box>
    )
  }
  return (
    <Box>
      <ImageList cols={3} gap={1} sx={{ marginTop: 0 }}>
        {outfits.map((outfit) => (
          <OutfitsListItem outfit={outfit} onPendingChange={onPendingChange} key={outfit.id} />
        ))}
      </ImageList>
    </Box>
  )
}
